import { inject, injectable } from 'inversify'
import {
  UpdateCompanyArticleUseCaseInput,
  UpdateCompanyArticleUseCaseOutput,
  IAppErrorFactory,
  IArticlesService,
  IUpdateCompanyArticleUseCase,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class UpdateCompanyArticleInteractor implements IUpdateCompanyArticleUseCase {
  @inject(symbols.IArticlesService) private articlesService: IArticlesService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: UpdateCompanyArticleUseCaseInput): Promise<UpdateCompanyArticleUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.article = await this.articlesService.updateCompanyArticle(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: '記事の更新に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): UpdateCompanyArticleUseCaseOutput {
    return {
      article: null,
      error: null,
    }
  }
}
